class Contributor {
  idContributorAux: number;

  name: string;

  email: string;

  invitationId?: number;

  invitationStatus?: string;

  contributions: number;

  // Picked while creating a vault (see pages/vault-new): their role, and for
  // a contributor whether they see the vault or only what they add.
  role?: ContributorType['role'];

  canViewVault?: boolean;

  constructor(data?: ContributorType) {
    this.idContributorAux = data?.idContributorAux || -1;
    this.name = data?.name || '';
    this.email = data?.email || '';
    this.invitationId = data?.invitationId || -1;
    this.invitationStatus = data?.invitationStatus || '';
    this.contributions = data?.contributions || 0;
    this.role = data?.role;
    this.canViewVault = data?.canViewVault;
  }
}

export { Contributor };
